// extracted by mini-css-extract-plugin
export default {"container":"GetStartedDescription_container__Jd6be"};